export const BRAND = {
  name: "erth. escapes",
  logoBlack: "/images/erth-black.png",
  logoWhite: "/images/erth-white.png",
  phone: "+91 80463 96067",
  phoneHref: "tel:+918046396067",
  whatsapp: "+91 88846 08383",
  whatsappHref: "https://wa.me/918884608383",
  email: "info@area83.in",
};

export const PROPERTIES = [
  {
    slug: "dune-villas",
    name: "Dune Villas",
    subtitle: "at Area 83",
    location: "Off Bannerghatta Road, Bengaluru",
    line: "Two private six-bedroom villas with a pool in each. Made for big groups, celebrations and unhurried stays.",
    image: "/images/exterior-hero.webp",
    alt: "Dune Villas at Area 83, the villa exterior in warm evening light",
    live: true,
  },
];
